import { Injectable } from '@angular/core';
import { BBService } from 'bookingbug-core-js';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';
@Injectable({
	providedIn: 'root',
})
export class DatastoreService {

	constructor(
		private router: Router
	) {
		this.isCitizenship$ = this.citizenship.asObservable();

	}

	// new function called agentRestart
	agentRestart() {
		// clear all localstorage
		localStorage.clear();

		//clear all session storage
		sessionStorage.clear();

		//clear variables
		this.startQuestions = null;
		this.uploadFilenames = {};
		this.type_of_appointment = null;
		this.appointment_type = null;
		this.totalCost = null;
		this.pageContent = null;
		this.reference = null;
		this.isCitizenshipRoute = null;
		this.dateCapInitDate = null; // used to cap calendar dates one year from entered date

		// client details
		this.booker_first_name = null;
		this.booker_last_name = null;
		this.booker_email = null;
		this.booker_phone = null;
		this.lookupResponses = [];
		this.formSubmissionResponses = [];
		this.costBreakDown = null;
		this.selectedAddress = null;
		this.setService = null;
		this.setResource = null;
		this.extraDuration = 0; // obtained from questions
		this.extraDurationsByQuestion = {};
		this.childDob = false;
		this.bookingQuestions = [];
		this.unselectedLocations = [];
		this.bookingForm = null;
		this.companyAnswers = null;
		this.selectedDate = null;
		this.selectedSlot = null;
		this.selectedResource = null;
		this.selectedService = null; //used only to store the service incase we switch to the alt one
		this.selectedDepartment = null; //used only to store the service incase we switch to the alt one
		this.locations = [];
		this.bookingAnswers = null;

		if (this.isCitizenshipRoute) {
			this.router.navigate(['/start/citizenship']);
			return;
		} else {
			this.router.navigate(['/agent']);
			return;
		}
	}

	startQuestions: any;

	/**
	 * RWRSPI-1106: a telephone or video appointment has no office address, so the
	 * summaries show this label as the location instead. It matches a key word
	 * in the answer text, not the question id, because question ids differ
	 * between staging and production, and the full answer text is edited often.
	 * Returns null for a face to face appointment.
	 */
	get remoteAppointmentLabel(): string | null {
		return this.remoteLabelFor(
			[this.startQuestions, this.companyQuestionsForm, this.bookingForm].flatMap((form) =>
				Object.values(form?.value ?? {})
			)
		);
	}

	/**
	 * The same label, read from a saved JRNI booking. After a payment the page
	 * reloads and the forms are empty, but the booking still holds the answers.
	 */
	remoteLabelForBooking(booking): string | null {
		return this.remoteLabelFor((booking?._embedded?.answers ?? []).map((answer) => answer?.value));
	}

	private remoteLabelFor(values: unknown[]): string | null {
		const answers = values
			.filter((answer): answer is string => typeof answer === 'string')
			.map((answer) => answer.toLowerCase());
		// ponytail: key-word match; breaks if one option's text mentions the other method
		if (answers.some((answer) => answer.startsWith('through') && answer.includes('telephon'))) {
			return 'Over a telephone call';
		}
		if (answers.some((answer) => answer.startsWith('through') && answer.includes('video'))) {
			return 'Over a video call';
		}
		return null;
	}

	/**
	 * RWRSPI-1091: filenames of files attached through the WCC upload box, keyed by
	 * question id. The answer itself only carries base64, so without this the box
	 * cannot show what is attached after the user navigates back to the page.
	 */
	uploadFilenames: { [questionId: string]: string } = {};
	type_of_appointment: any;
	appointment_type: any;
	public totalCost: any;
	public pageContent: any;

	public firstSlotAnalytic: any;
	public firstSlotAnalyticKey: string;

	public reference: any;
	public isCitizenshipRoute: any;
	public dateCapInitDate: any; // used to cap calendar dates one year from entered date

	// client details
	public booker_first_name: any;
	public booker_last_name: any;
	public booker_email: any;
	public booker_phone: any;
	public lookupResponses: any[] = [];
	// Separate from lookupResponses: a different API reads each (RWRSPI-1095).
	public formSubmissionResponses: any[] = [];
	public costBreakDown: any;
	public selectedAddress: any;

	public setService: any;
	public setResource: any;
	public staff_set: any;
	public autoSelectedStaff: any;

	public extraDuration = 0; // obtained from questions
	public extraDurationsByQuestion: Record<string, number> = {};

	setQuestionExtraDuration(questionId: string | number, minutes: number) {
		const key = String(questionId);
		const value = Number(minutes) || 0;
		if (value > 0) {
			this.extraDurationsByQuestion[key] = value;
		} else {
			delete this.extraDurationsByQuestion[key];
		}
		this.extraDuration = Object.values(this.extraDurationsByQuestion).reduce(
			(sum, v) => sum + v,
			0
		);
	}

	public childDob: any = false;

	public bookingQuestions = [];

	public unselectedLocations = [];

	public bookingForm;
	public companyAnswers;

	public selectedDate;

	public selectedSlot;

	public selectedResource;

	public selectedService; //used only to store the service incase we switch to the alt one
	public selectedDepartment; //used only to store the service incase we switch to the alt one

	public locations = [];

	public bookingAnswers;

	public customerDetailsForm;

	public client;

	public clientCreated = false;

	public address;

	public latitude;

	public longitude;

	public endSlot;

	public customerQuestions;

	public companyQuestions;

	public address1;

	public companyQuestionsForm;

	public selectedLocation;

	public booking;

	public totalPrice;

	public adminJourney = false;

	public adminAuthToken = '';

	public purchase: any;

	public serviceBookingType: any;

	public selectedSuggestion: any;

	public config: any;

	public serviceFees: any;

	public ceremonyDate: any;

	public deathDate: any;

	public mccdRegDate: any;

	public journeyRoute: string;

	public skipLocationsPage = false;

	public postageCounts: any;

	public citizenshipFees = {
		'mon_fri_9_5': {
			'individual': "39513c0d-0285-4bf9-b157-46167197cbf3",
			'family': "8d8d9a69-8da9-48bf-9730-30aba2116561",
		},
		'mon_fri_after_5': {
			'individual': "863e1bdd-844e-4224-b499-157cbd14df4e",
			'family': "bfab1b27-6c4b-44fb-827b-70b116d96baa"
		},
		'sat': {
			'individual': "b22c83a6-9c41-4d3f-b40c-c6bc14ebb014",
			'family': "c715847a-69c3-4f42-836f-7a34267cad10"
		},
		'sun': {
			'individual': "168bee11-5865-49ee-8a55-836532bd149b",
			'family': "a7d74984-1a78-44a8-b4f5-c77aa194fd18"
		}
	};
	public citizenshipGroupFees = {
		'mon_fri_9_5': {
			'individual': "e9c0a49a-bcdc-44be-9e57-c785021b3873",
			'family': "a0cf3768-105d-4e7f-bfb9-7944b2e8d54e",
		},
		'mon_fri_after_5': {
			'individual': "0e76a78f-da50-41a0-964c-05d386c8a59f",
			'family': "22a67b6d-5a89-46c6-8678-5e36302e55c6"
		},
		'sat': {
			'individual': "428633ba-ca49-4f96-ae4b-7d5b9fac7477",
			'family': "031b5378-25ed-4a3a-b433-03154165b617"
		},
		'sun': {
			'individual': "b8dc511d-40d6-4149-bcb0-60c2edc9f6af",
			'family': "b7db38d8-b58b-4cc8-814e-66508c1fcbf6"
		}
	};
	public citizenshipKey = '';

	public familyCitizenshipBooking = false;

	public groupCitizenshipBooking = false;

	// How many places on a group citizenship ceremony this booking will take up.
	// Set from the questions page, compared against citizenshipAvailability in the
	// calendar (SUP-2588). Defaults to a party of one.
	public citizenshipRequiredPlaces = 1;

	public citizenshipExtraItem;

	notify: Subject<boolean> = new Subject<boolean>();
	onNotify(event) {
		this.notify.next(true);
	}

	private addFeesSubject = new BehaviorSubject<any>(null);
	addFees$ = this.addFeesSubject.asObservable();
	triggerAddFees(fees: any) {
		this.addFeesSubject.next(fees);
	}



	public citizenship: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public isCitizenship$: Observable<boolean>;
	updateCitizenship(val: boolean) {
		this.citizenship.next(val);
	}

	public certificateStore: any;

	public applicationStore:
		| {
			formData: Record<string, string> | undefined;
			applicationType: string;
			formId: string;
			applicationNumber: string | undefined;
		}
		| undefined;
}
